import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../Container';
import Image from '../Image/index';

const space = '10px';

export const StyledFooter = styled.footer`
  background-color: ${themeGet('colors.white')};
  padding: 60px 0 0;
  a,
  button,
  p,
  li {
    color: ${themeGet('colors.black')};
    border: none;
    &:focus,
    &:hover {
      border: none;
    }
  }
  // Footer CookieConsent bar
  .CookieConsent {
    padding: 10px;
    flex-flow: row nowrap;
    @media only screen and (min-width: ${themeGet('breakpoints.xs')}) {
      padding: 26px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 20px 70px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 23px 90px 16px 90px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
      padding: 23px 120px 16px 120px;
    }
  }
  //text content
  .footerTextContent {
    display: flex;
    color: #000;
    margin: 0;
    align-items: center;
    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding-right: 20px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
      padding-right: 50px;
    }
  }
  //button
  .footerButtons {
    display: flex;
    align-self: center;
    font-size: 18px;
    color: #000;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
      width: auto;
    }
  }
`;

export const Logo = styled.img`
  height: 100%;
  max-height: 37px;
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 30px;
  }
`;

export const TopRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 0px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: calc(${space} * 5);
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const BottomRow = styled.div`
  background-color: #5b6065;
`;

// * This is the styled {UL} that contains links like Privacy policy and Terms and Conditions
export const StyledBottomContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  a {
    margin: 0 10px;
    list-style: none;
    font-size: 16px;
    letter-spacing: -0.21px;
    line-height: 30px;
    font-weight: normal;
    &:hover,
    &:focus {
      color: ${themeGet('colors.white')};
      opacity: 0.8;
    }
  }
  a,
  p {
    color: ${themeGet('colors.white')};
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: flex-end;
  }
`;

export const LeftContainer = styled.div`
  width: auto;
  margin-bottom: 40px;
  a span,
  a span img {
    display: block;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-right: 75px;
    display: block;
    margin-bottom: 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin-right: 100px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    margin-right: 150px;
  }
`;

export const LinksAndBadgesWrapper = styled.div`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    display: flex;
    padding-bottom: 40px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-bottom: 0px;
  }
`;

export const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -${space};
  a {
    font-weight: normal;
    font-size: 15px;
    letter-spacing: -0.2px;
    line-height: 32px;
    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-wrap: nowrap;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 650px;
  }
`;

export const Badge = styled(Image)`
  height: auto;
  width: 100%;
  max-height: 78px;
`;

export const RightContainer = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  &.no-bullets {
    margin: auto;
  }
  li {
    margin: 0;
    width: 50%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  & li:nth-child(3) {
    width: 50%;
  }
  & li:nth-child(1) {
    margin-right: 10px;
  }
  & li:nth-child(2) {
    margin-right: 20px;
  }
  & li:nth-child(1) img,
  & li:nth-child(3) img {
    padding-top: 5px;
  }
  @media only screen and (max-width: ${themeGet('breakpoints.xs')}) {
    & li:nth-child(3) {
      margin-top: 15px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
    max-width: 200px;
    && {
      margin: 0;
      margin-left: auto;
    }
    & li:nth-child(1),
    & li:nth-child(2) {
      margin-right: 0px;
    }
    & li:nth-child(1) img {
      max-height: 67px;
    }
    & li:nth-child(2) img {
      max-height: 72px;
    }
    & li:nth-child(3) {
      align-items: center;
      width: 100%;
      padding-top: unset;
    }
    li {
      margin: 5px 0;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 200px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${space};
  margin-bottom: 30px;
  & :nth-child(odd) {
    flex: 0 1 60%;
  }
  & :nth-child(even) {
    flex: 0 1 40%;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* This fixes IE flex calc bug */
    flex: 0 1 45%;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;
    & :nth-child(odd),
    & :nth-child(even) {
      flex: 1 1 auto;
    }
  }
`;

export const Heading = styled.p`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.24px;
  line-height: 21px;
  margin-bottom: 10px;
`;

export const SocialLinks = styled.div`
  position: absolute;
  bottom: 35px;
  display: flex;
  flex-direction: row;
  margin: 0 -10px;
  width: 100%;
  justify-content: center;
  a {
    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }
  img {
    margin: 0 10px;
    height: 100%;
    width: 100%;
    max-height: 24px;
    max-width: 24px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    position: static;
    bottom: auto;
    width: unset;
    justify-content: left;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  min-height: 50px;
  background-color: #f2f8e8;
  color: ${({ footerInfoFontColor }) =>
    footerInfoFontColor || themeGet('colors.black')};
  .infobar-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: left;
    }
    @media (max-width: ${themeGet('breakpoints.lg')}) {
      padding: 20px 50px;
    }
    @media (max-width: ${themeGet('breakpoints.md')}) {
      flex-direction: column;
      text-align: left;
      padding: 20px 0 30px 0;
    }
  }
  h3 {
    font-size: 16px;
    color: inherit;
  }
  a {
    color: ${themeGet('colors.orange')};
  }
`;

export const StyledLink = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: ${themeGet('fonts.primary')};
  font-weight: ${themeGet('font-weights.bold')};
  text-align: center;
  border-radius: 4px;
  border-width: 3px;
  border-style: solid;
  text-decoration: none;
  font-size: 18px;
  letter-spacing: -0.5px;
  line-height: 21px;
  height: 48px;
  min-height: 48px;
  margin-left: 10px;
  transition: all 500ms ease;
  @media (max-width: ${themeGet('breakpoints.md')}) {
    margin-left: 0;
  }

  //todo: switch this to global CTA styles and correct solid-on-dark there to brand orange, test dark orange is not used elsewhere first
  &.solid-on-light-bg,
  &.solid-on-dark-bg {

    width: 216px;
    border-color: ${themeGet('colors.orange')};
    background-color: ${themeGet('colors.orange')};
    color: ${themeGet('colors.white')};
    &:hover,
    &:focus {
      border-color: ${themeGet('colors.dark-orange')};
      background-color: ${themeGet('colors.dark-orange')};
      color: ${themeGet('colors.white')};
    }
    &:focus,
    &:active {
      border-color: ${themeGet('colors.darkest-orange')};
      background-color: ${themeGet('colors.darkest-orange')};
      color: ${themeGet('colors.white')};
    }
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    }
    @media only screen and (max-width: ${themeGet('breakpoints.sm')}) {
      min-width: 120px;
      width: 150px;
    }
  }
  &.ghost-on-light-bg {
    border-color: ${themeGet('colors.orange')};
    background-color: white;
    color: ${themeGet('colors.black')};
    min-width: 120px;
    width: 100px;

    &:hover,
    &:focus {
      color: ${themeGet('colors.white')};
      border-color: ${themeGet('colors.orange')};
      background-color: ${themeGet('colors.orange')};
    }
    &:focus,
    &:active {
      color: ${themeGet('colors.white')};
      border-color: ${themeGet('colors.orange')};
      background-color: ${themeGet('colors.orange')};
    }
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      width: 140px;
      margin-left: 9px;
    }
  }
`;
